export default __webpack_public_path__ + "static/media/speed_slow_icon_bold.9b07b281.svg";